import { ReactComponentType } from "Types";

export type FunctionalComponent = React.FC<any>;

export interface IRouteConfig {
  isExact: boolean;
  title: string;
  path: string;
  component: ReactComponentType;
  active?: boolean;
  permissions?: number[];
}

export class RouteConfig implements IRouteConfig {
  constructor(
    subRoute: string,
    component: ReactComponentType,
    alternateTitle = subRoute.substring(1),
    alternatePath = subRoute,
    isExact = true,
    permissions: number[] = []
  ) {
    this.isExact = isExact;
    this.component = component;
    this.title = alternateTitle;
    this.path = alternatePath;
    this.permissions = permissions;
    this.route = alternatePath;
    this.fullRoute = alternatePath;
    this.label = "";
  }

  isExact: boolean;
  component: ReactComponentType;
  title: string;
  path: string;
  active?: boolean;
  permissions?: number[];
  icon?: React.ReactNode;
  route: string;
  label: string;
  fullRoute?: string;
  navItemsUrl?: string;
  default?: boolean;
  hideInSidebar?: boolean;
  children?: NavConfigItem[];
  showInDropdown?: boolean;
  subRouteName?: string;
}

export interface IRouteMap {
  [x: string]: IRouteConfigMap;
}

export interface IRouteConfigMap {
  [x: string]: IRouteConfig;
}

export type NavConfigItem = {
  label: string;
  icon?: React.ReactNode;
  route: string;
  fullRoute?: string;
  navItemsUrl?: string;
  permissions?: number[];
  active?: boolean;
  default?: boolean;
  component?: FunctionalComponent;
  hideInSidebar?: boolean;
  children?: NavConfigItem[];
  showInDropdown?: boolean;
  subRouteName?: string;
};
